import { Row } from 'react-bootstrap';
import '../styles/components/info-modal-section.scss';
import AccordionContainer from './AccordionContainer';
import FormatTable from './FormatTable';

const CompSerialNumDescription = () => {
  return (
    <>
      <Row className="section">
        <h2>Overview</h2>
        <p className="text-start">Available approximately June 1</p>
      </Row>
      <AccordionContainer id="compSerialNumAccordion">
        <FormatTable title="Complete Tax Serial Number File" />
      </AccordionContainer>
    </>
  );
};

export default CompSerialNumDescription;
